module.exports = __webpack_public_path__ + "img/UTFLIG-3.ef8e2f9b.jpg";